import instance from "../../api";

export const getHuntersReports = (filters) => {
  return instance(true)
    .post(`/crm/kpi/v1/hunters_report/`, filters)
    .then((res) => {
      return res?.data;
    });
};

export const getPlans = (filters) => {
  return instance(true)
    .get(`/crm/kpi/v1/sd_plans/`, { params: filters })
    .then((res) => {
      return res?.data;
    });
};

/**
 * kpi_hunter__read_v1 does not return hunter_month_plan_id.
 * Resolve it via GET hunters_month_plan for read-only penalties.
 */
export const getHuntersMonthPlans = (filters) => {
  return instance(true)
    .get(`/crm/kpi/v1/hunters_month_plan/`, {
      params: {
        year: filters.year,
        month: filters.month,
        sale_department_id: filters.sale_department_id || "",
      },
    })
    .then((res) => {
      return res?.data;
    });
};

export const getArchivePenalties = (hunterMonthPlanId) => {
  return instance(true)
    .get(`/crm/kpi/v1/hunters_month_plan/${hunterMonthPlanId}/penalties/`)
    .then((res) => {
      return res?.data;
    });
};
